import * as React from 'react';
import { Link } from 'react-router-dom';

import {
  IconWrapper,
  SContent,
  SMaterialCard,
  STitle,
} from 'components/Information/Information.styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import NooderaButton from 'components/NooderaButton';

export type InformationProps = {
  type: 'warning' | 'info';
  title: React.ReactElement<any> | React.ReactElement<any>[] | string;
  content: React.ReactElement<any> | React.ReactElement<any>[] | string;
  buttonContent?: {
    text: string;
    redirectUrl?: string;
    buttonFn?: React.MouseEventHandler<any> | undefined;
  };
  icon?: React.ReactElement<any> | undefined;
  width?: string;
  marginBottom?: boolean;
};

const Information = ({
  type = 'info',
  title,
  content,
  buttonContent = null,
  icon = null,
  width = null,
  marginBottom,
}: InformationProps): React.ReactElement<any> | null => {
  const renderBtn = (): React.ReactElement<any> | null => {
    if (!buttonContent) {
      return null;
    }

    if (buttonContent?.redirectUrl) {
      return (
        <Link to={buttonContent?.redirectUrl}>
          <NooderaButton size='medium'> {buttonContent?.text} </NooderaButton>
        </Link>
      );
    }

    if (buttonContent?.buttonFn) {
      return (
        <NooderaButton
          size='medium'
          onClick={buttonContent?.buttonFn}
          style={{ whiteSpace: 'nowrap' }}
        >
          {buttonContent?.text}
        </NooderaButton>
      );
    }

    return null;
  };

  const renderIcon = (): React.ReactElement<any> => {
    if (icon) {
      return icon;
    }
    if (type === 'warning') {
      return <WarningAmberIcon />;
    }
    return <InfoOutlinedIcon />;
  };

  return (
    <SMaterialCard
      type={type}
      width={width}
      marginBottom={marginBottom}
      data-testid='information-banner'
    >
      <IconWrapper type={type}>{renderIcon()}</IconWrapper>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <STitle>{title}</STitle>
          <SContent>{content}</SContent>
        </div>
        {renderBtn()}
      </div>
    </SMaterialCard>
  );
};

export default Information;
